document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".custom-feature-icons-section").forEach(section => {
    const slider = section.querySelector(".custom-feature-slider"),
          track = section.querySelector(".custom-feature-track"),
          prev = section.querySelector(".custom-feature-arrow.prev"),
          next = section.querySelector(".custom-feature-arrow.next"),
          dotsWrap = section.querySelector(".custom-feature-dots");
    if (!slider || !track) return;

    let i = 0, timer, startX = 0;

    const show = () => innerWidth <= 600 ? 1 : innerWidth <= 925 ? 2 : 3;
    const items = () => [...track.querySelectorAll(".custom-feature-item:not(.clone)")];
    const total = () => items().length;
    const real = () => ((i - show()) % total() + total()) % total();

    const setDots = () => {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = "";
      items().forEach((_, n) => {
        const b = document.createElement("button");
        b.className = "custom-feature-dot" + (n === real() ? " active" : "");
        b.onclick = () => { i = show() + n; move(); auto(); };
        dotsWrap.appendChild(b);
      });
    };

    const move = (anim = true) => {
      const w = 100 / show();
      track.querySelectorAll(".custom-feature-item").forEach(el => {
        el.style.flex = `0 0 ${w}%`;
        el.style.maxWidth = `${w}%`;
      });
      track.style.transition = anim ? ".5s ease" : "none";
      track.style.transform = `translateX(-${i * w}%)`;
      dotsWrap?.querySelectorAll(".custom-feature-dot")
        .forEach((d, n) => d.classList.toggle("active", n === real()));
    };

    const clone = () => {
      track.querySelectorAll(".clone").forEach(el => el.remove());
      const s = show(), arr = items();
      for (let k = s - 1; k >= 0; k--) {
        const a = arr[arr.length - 1 - k]?.cloneNode(true);
        if (a) { a.classList.add("clone"); track.prepend(a); }
      }
      for (let k = 0; k < s; k++) {
        const a = arr[k]?.cloneNode(true);
        if (a) { a.classList.add("clone"); track.append(a); }
      }
      i = s;
      move(false);
      setDots();
    };

    const loop = () => {
      const s = show(), t = total();
      if (i >= t + s) { i = s; move(false); }
      if (i < s) { i = t + s - 1; move(false); }
    };

    const auto = () => {
      clearInterval(timer);
      timer = setInterval(() => { i++; move(); }, 5000);
    };

    next?.addEventListener("click", () => { i++; move(); auto(); });
    prev?.addEventListener("click", () => { i--; move(); auto(); });

    slider.addEventListener("mouseenter", () => clearInterval(timer));
    slider.addEventListener("mouseleave", auto);

    slider.addEventListener("mousedown", e => { startX = e.clientX; clearInterval(timer); });
    slider.addEventListener("mouseup", e => {
      if (startX - e.clientX > 50) i++;
      if (e.clientX - startX > 50) i--;
      move(); auto();
    });

    slider.addEventListener("touchstart", e => { startX = e.touches[0].clientX; clearInterval(timer); });
    slider.addEventListener("touchend", e => {
      const endX = e.changedTouches[0].clientX;
      if (startX - endX > 50) i++;
      if (endX - startX > 50) i--;
      move(); auto();
    });

    track.addEventListener("transitionend", loop);
    addEventListener("resize", clone);

    clone();
    auto();
  });
});



document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".custom-image-gallery-section").forEach(section => {
    const slider = section.querySelector(".custom-image-gallery-slider"),
          track = section.querySelector(".custom-image-gallery-track"),
          dotsWrap = section.querySelector(".custom-image-gallery-dots");

    if (!slider || !track) return;

    let i = 0, timer, startX = 0;

    const show = () => innerWidth <= 600 ? 1 : innerWidth <= 925 ? 2 : 3;
    const items = () => [...track.querySelectorAll(".custom-image-gallery-item:not(.clone)")];
    const total = () => items().length;
    const real = () => ((i - show()) % total() + total()) % total();

    const setDots = () => {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = "";
      items().forEach((_, n) => {
        const b = document.createElement("button");
        b.className = "custom-image-gallery-dot" + (n === real() ? " active" : "");
        b.onclick = () => {
          i = show() + n;
          move();
          auto();
        };
        dotsWrap.appendChild(b);
      });
    };

    const move = (anim = true) => {
      const itemsAll = [...track.querySelectorAll(".custom-image-gallery-item")];
      const visible = show();
      let offset = 0;

      itemsAll.forEach((el, idx) => {
        let w = 100 / visible;

     if (window.innerWidth > 925 && visible === 3) {

  if (
    document.body.classList.contains("index-template") ||
    document.body.classList.contains("template-index") ||
    document.body.classList.contains("index")
  ) {

    if (idx === i) {
      w = 40;
      el.classList.add("is-active");

    } else if (idx === i + 1) {
      w = 30;
      el.classList.remove("is-active");

    } else if (idx === i + 2) {
      w = 30;
      el.classList.remove("is-active");

    } else {
      w = 33.333333;
      el.classList.remove("is-active");
    }

  } else {
    w = 33.333333;
    el.classList.remove("is-active");
  }

} else {
  el.classList.remove("is-active");
}

        el.style.flex = `0 0 ${w}%`;
        el.style.maxWidth = `${w}%`;

        if (idx < i) offset += w;
      });

      track.style.transition = anim ? "transform .5s ease" : "none";
      track.style.transform = `translateX(-${offset}%)`;

      dotsWrap?.querySelectorAll(".custom-image-gallery-dot")
        .forEach((d, n) => d.classList.toggle("active", n === real()));
    };

    const clone = () => {
      track.querySelectorAll(".clone").forEach(el => el.remove());
      const s = show(), arr = items();

      for (let k = s - 1; k >= 0; k--) {
        const a = arr[arr.length - 1 - k]?.cloneNode(true);
        if (a) {
          a.classList.add("clone");
          track.prepend(a);
        }
      }

      for (let k = 0; k < s; k++) {
        const a = arr[k]?.cloneNode(true);
        if (a) {
          a.classList.add("clone");
          track.append(a);
        }
      }

      i = s;
      move(false);
      setDots();
    };

    const loop = () => {
      const s = show(), t = total();
      if (i >= t + s) {
        i = s;
        move(false);
      }
      if (i < s) {
        i = t + s - 1;
        move(false);
      }
    };

    const auto = () => {
      clearInterval(timer);
      timer = setInterval(() => {
        i++;
        move();
      }, 5000);
    };

    slider.addEventListener("mouseenter", () => clearInterval(timer));
    slider.addEventListener("mouseleave", auto);

    slider.addEventListener("mousedown", e => {
      startX = e.clientX;
      clearInterval(timer);
    });

    slider.addEventListener("mouseup", e => {
      if (startX - e.clientX > 50) i++;
      if (e.clientX - startX > 50) i--;
      move();
      auto();
    });

    slider.addEventListener("touchstart", e => {
      startX = e.touches[0].clientX;
      clearInterval(timer);
    });

    slider.addEventListener("touchend", e => {
      const endX = e.changedTouches[0].clientX;
      if (startX - endX > 50) i++;
      if (endX - startX > 50) i--;
      move();
      auto();
    });

    track.addEventListener("transitionend", loop);
    addEventListener("resize", clone);

    clone();
    auto();
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const phoneInput = document.querySelector('#ContactForm-phone-template--19670492709017__contact_form_DjzAGy');

  phoneInput.addEventListener("input", function () {
    this.value = this.value.replace(/[^0-9]/g, '');
  });
});




// Shop Page filter dropdown //


document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const sortBy = params.get('sort_by');
  const path = window.location.pathname;

  if (!sortBy) return;

  let productGrid = null;

  if (path.includes('/search')) {
    productGrid =
      document.querySelector('.main-search__results .f-grid') ||
      document.querySelector('.template-search .f-grid') ||
      document.querySelector('.search-results .f-grid') ||
      document.querySelector('.product-grid') ||
      document.querySelector('[data-search-results]');
  }

  if (path.includes('/collections/')) {
    productGrid =
      document.querySelector('.main-collection-product-grid .f-grid') ||
      document.querySelector('.collection .f-grid') ||
      document.querySelector('.template-collection .f-grid') ||
      document.querySelector('.product-grid') ||
      document.querySelector('[data-collection-products]');
  }

  if (!productGrid) return;

  const productCards = Array.from(productGrid.children);

  function getPrice(card) {
    const priceEl =
      card.querySelector('.price') ||
      card.querySelector('.price-item--regular') ||
      card.querySelector('.price-item') ||
      card.querySelector('.f-price') ||
      card.querySelector('[class*="price"]');

    if (!priceEl) return 0;

    const text = priceEl.textContent.replace(/[^0-9.,]/g, '').replace(/,/g, '');
    const price = parseFloat(text);
    return isNaN(price) ? 0 : price;
  }

  if (sortBy === 'price-descending') {
    productCards.sort((a, b) => getPrice(b) - getPrice(a));
  } else if (sortBy === 'price-ascending') {
    productCards.sort((a, b) => getPrice(a) - getPrice(b));
  } else {
    return;
  }

  productCards.forEach(card => productGrid.appendChild(card));
});


// Shop Page filter dropdown //

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-menu-select').forEach(function (dropdown) {
    const toggle = dropdown.querySelector('.custom-menu-toggle');

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      dropdown.classList.toggle('open');
    });

    dropdown.querySelectorAll('.child-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        btn.closest('.menu-item').classList.toggle('active');
      });
    });

    document.addEventListener('click', function () {
      dropdown.classList.remove('open');
    });
  });
});
